import React from "react";
import RecruitmentLandingPage from "../../recruitment-shared/pages/RecruitmentLandingPage";

export default function NonFacultyLandingPage() {
  return <RecruitmentLandingPage type="NON_FACULTY" />;
}
